import { __assign } from "tslib";
import { renderAndMountComponent } from '@wix/answers-lib';
import * as React from 'react';
import { DeprecatedTextArea, deprecatedTextAreaKey } from '../..';
import { getLegacyBaseDriverFromWrapper, simulateBlur } from '../../common/base-driver';
export var createDeprecatedTextAreaDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, "." + deprecatedTextAreaKey, DeprecatedTextArea.name);
    var textArea = baseDriver.elem;
    return {
        getValue: function () { return textArea.value; },
        enterValue: function (value) { return baseDriver.enterValue(value); },
        blur: function () { return simulateBlur(textArea); },
        isDisabled: function () { return textArea.hasAttribute('disabled'); },
        isReadOnly: function () { return textArea.hasAttribute('readonly'); }
    };
};
export var createDeprecatedTextArea = function (props) {
    var elem = renderAndMountComponent(React.createElement(DeprecatedTextArea, __assign({}, props)));
    return createDeprecatedTextAreaDriver(elem);
};
//# sourceMappingURL=text-area.driver.js.map